module.exports = __webpack_public_path__ + "media/images/team_tubc-8e847cfcaf1a87d5adbe6763153c9d2a.png";